import { render } from "./ControlLabel.vue?vue&type=template&id=5365007c&scoped=true"
import script from "./ControlLabel.vue?vue&type=script&lang=js"
export * from "./ControlLabel.vue?vue&type=script&lang=js"

import "./ControlLabel.vue?vue&type=style&index=0&id=5365007c&lang=css"
import "./ControlLabel.vue?vue&type=style&index=1&id=5365007c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5365007c"]])

export default __exports__